export default "__VITE_ASSET__r9$ns9X7__"